module.exports = __webpack_public_path__ + "stylesheets/landing-new-bottom_8d07518e090871d93296352714c52bc8.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/landing-new-bottom.less
// module id = LT3T
// module chunks = 118